import React from 'react';
import { Link } from 'gatsby';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import Layout from '../components/Layout/Layout';
import Seo from '../components/Seo';
import NotFoundBanner from '../images/404.svg';

const NotFoundPage = () => {
  return (
    <Layout>
      <Seo title="404: Page Not Found | Integra Connect" />

      <Container>
        <Row className="vh-100 align-items-center justify-content-center">
          <Col md={4}>
            <h1 className="fw-bold mb-1 mt-0">
              404: <span className="fw-light">Not Found</span>
            </h1>

            <p className="mb-4">
              The link is broken or the page has been moved.
            </p>
            <Button variant="primary" as={Link} to="/">
              Back to Home
            </Button>
          </Col>
          <Col md={4}>
            <img
              src={NotFoundBanner}
              alt="Not found"
              className="mb-4 d-lg-block img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default NotFoundPage;
